import OperatorStationPage from "../components/OperatorStationPage";

export default function IstasyonParcalamaPage() {
  return (
    <OperatorStationPage
      config={{
        role: "Parçalama Operatörü",
        title: "Parçalama Operatörü",
        subtitle: "Sadece kesimi tamamlanan hayvanları parçalamaya alır veya direkt tamamlar.",
        status: "cut",
        actionLabel: "Parçalamaya Al",
        actionVariant: "primary",
        nextStatus: undefined,
        allowDirectDone: true,
        allowPackingZone: true,
      }}
    />
  );
}
